import * as React from 'react';
import styled from 'styled-components';
import { StyledSystemProps } from '../../theme/StyledSystemProps';
import { Label } from '../../typography';

type Props = StyledSystemProps & {
  bg?: string;
  name?: string;
  type?: string;
  color?: string;
  width?: string;
  height?: string;
  paddingLeft?: string;
  boxShadow?: string;
  placeholder?: string;
  showEyeIcon?: boolean;
  passwordVisible?: boolean;
  children?: React.ReactNode;
  onTogglePassword?: () => void;
  disabled?: boolean;
  borderRadius?: string | number;
  id?: string;
  onChange?: (e: any) => void;
  autoComplete?: string;
  value?: string;
  min?: number;
  max?: number;
  field: any;
  label: string;
};

const InputWrap = styled.div`
  flex: 1 0 48%;
  margin-bottom: 15px;
  margin-right: 20px;
  display: flex;
  position: relative;
  align-items: center;
  word-wrap: break-word;
  justify-content: center;
  flex-direction: column;
  box-sizing: border-box;
  @media screen and (min-width: 52em) {
    flex: 1 0 23%;
  }
`;

const Attachments: React.FC<Props> = (props: Props) => {
  const { field: { value } } = props;
  return (
    <InputWrap>
      <Label>{props.label}</Label>
      {value.map((link: string, index: number) => (
        <>
          <a style={{ wordWrap: 'break-word' }} href={link} key={index} target="_blank">{link}</a>
          <br />
        </>
      ))}
      {value.length === 0 && <i>No files uploaded</i>}
    </InputWrap>
  );
};

export default Attachments;

Attachments.defaultProps = {
  bg: 'paleGrey',
  field: { value: [] },
  borderRadius: 4,
};



// WEBPACK FOOTER //
// ./src/components/formElements/StyledAttachments.tsx